export default "__VITE_ASSET__bd3d0458__"